import { EventName } from './eventsName';

type GameEventListeners = {
    cb: (data: any, listener: ListenerData) => void;
    id: string;
};
export type ListenerData = { id: string; key: string };

let eventIndex = 0;
class GameEventClass {
    listeners = {} as { [key in EventName]: GameEventListeners[] };
    emit(key: EventName, data?: any) {
        if (!this.listeners[key]) return;
        this.listeners[key].forEach((e) => {
            e.cb(data, { id: e.id, key });
        });
    }
    add(key: EventName, cb: (data: any, listener: ListenerData) => void) {
        if (!this.listeners[key]) this.listeners[key] = [] as GameEventListeners[];
        const id = this.newEventId(key);
        this.listeners[key].push({
            id,
            cb,
        });
        return id;
    }
    remove(id: string) {
        const key = id.split('_')[1] as EventName;
        if (this.listeners[key]) this.listeners[key] = this.listeners[key].filter((e) => e.id !== id);
        // else console.warn('no events for', id);
    }
    newEventId(key: string) {
        eventIndex++;
        return `eventid_${key}_${eventIndex}`;
    }
}

export const GameEvent = new GameEventClass();
